import { render } from "./OverlaysDemo.vue?vue&type=template&id=4eeb1a66&scoped=true"
import script from "./OverlaysDemo.vue?vue&type=script&lang=js"
export * from "./OverlaysDemo.vue?vue&type=script&lang=js"

import "./OverlaysDemo.vue?vue&type=style&index=0&id=4eeb1a66&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eeb1a66"]])

export default __exports__